import React, { type VFC } from 'react';

import { PageSegmentLoadStart } from '@confluence/browser-metrics/entry-points/PageSegmentLoadStart.ts';
import { APP_NAVIGATION_METRIC } from '@confluence/browser-metrics/entry-points/app-navigation.metric.ts';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { ErrorBoundary } from '@confluence/error-boundary/entry-points/ErrorBoundary.ts';

import { TopNavigation } from '../src/TopNavigation.tsx';
import type { useCustomTheme } from '../src/theme/useCustomTheme.ts';

export const TopNavigationBase: VFC<{
	defaultCollapsed: boolean;
	customTheme: ReturnType<typeof useCustomTheme>;
}> = ({ defaultCollapsed, customTheme }) => {
	return (
		<ErrorBoundary
			attribution={Attribution.DISCO}
			attributes={{
				errorBoundaryId: 'TopNavigation',
			}}
		>
			<PageSegmentLoadStart metric={APP_NAVIGATION_METRIC} />
			<TopNavigation defaultCollapsed={defaultCollapsed} customTheme={customTheme} />
		</ErrorBoundary>
	);
};
